import styled from "styled-components";

export const Aside = styled.aside`
  background-color: white;
`;
